import React from 'react'

import { useIdleTimer } from 'react-idle-timer'

import { connect } from 'react-redux'
import ScrollTop from 'partials/layout/ScrollTop'
import HTMLClassService from './HTMLClassService'
import LayoutConfig from './LayoutConfig'
import LayoutInitializer from './LayoutInitializer'
import KtContent from './KtContent'
import InactivityModal from './InactivityModal'

import AppHeader from './custom/AppHeader'
import AppSubHeader from './custom/AppSubHeader'
import AppSidebar from './custom/AppSidebar'

import './assets/Base.scss'

const htmlClassService = new HTMLClassService()
const INACTIVITY_WARNING_TIMEOUT = 1000 * 60 * (24 * 60 - 3)

function Layout({ children, layoutConfig }) {
  const [mostrarModalInactividad, setMostrarModalInactividad] = React.useState(false)

  htmlClassService.setConfig(layoutConfig)

  const handleOnIdle = () => {
    if (!mostrarModalInactividad) {
      setMostrarModalInactividad(true)
    }
  }

  useIdleTimer({
    timeout: INACTIVITY_WARNING_TIMEOUT,
    onIdle: handleOnIdle,
    debounce: 500
  })

  return (
    <>
      <LayoutInitializer layoutConfig={LayoutConfig} htmlClassService={htmlClassService}>
        <div className='page'>
          <div className='page-main'>
            <AppHeader />
            <AppSubHeader />
            <AppSidebar />
            <div className='app-content'>
              <div className='side-app'>
                <div id='kt_content' className='kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor'>
                  {/* <!-- begin:: Content Body --> */}
                  <KtContent>{children}</KtContent>
                  {/*<!-- end:: Content Body -->*/}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ScrollTop />
      </LayoutInitializer>
      {mostrarModalInactividad && <InactivityModal show={mostrarModalInactividad} handleClose={() => setMostrarModalInactividad(false)} />}
    </>
  )
}

const mapStateToProps = ({ builder: { layoutConfig } }) => ({
  layoutConfig
})

export default connect(mapStateToProps)(Layout)
